module.exports = __webpack_public_path__ + "media/images/logo-852cc92fcb667ecc4c8ed68a8cb9cab6.ico";